import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

export const useDuplicateOrder = ({
  orderId,
  data,
  onSuccess,
  onError,
}: {
  orderId: string;
  data: { permitsToCopy: string[] };
  onSuccess: (duplicatedOrderId: string) => void;
  onError: () => void;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      return await OrdersClient.duplicateOrder(orderId, data);
    },
    onSuccess: (newOrderId: string) => {
      onSuccess(newOrderId);
    },
    onError: () => {
      onError();
    },
  });
  return {
    duplicateOrder: mutate,
    isLoading: isPending,
  };
};
